import { Input, Select, Table } from "antd";
import { useEffect, useState } from "react";
import { IReserveItem } from "../../../../../types/property";
import NumberField from "../../../../shared/number-field";
const { Option } = Select;

interface IAdditionalReservesDetailsReTaxesProps {
  reserveItem: IReserveItem;
  onFormChange(item: IReserveItem): void;
}

const AdditionalReservesDetailsReTaxes = ({ reserveItem: { months, release, releaseMonths, yearOneMonthlyAmount, yearOneTotal, yearOneTotalPerUnit}, onFormChange }: IAdditionalReservesDetailsReTaxesProps) => {
  const [form, setForm] = useState<IReserveItem>({
    months,
    release,
    releaseMonths,
    yearOneMonthlyAmount,
    yearOneTotal,
    yearOneTotalPerUnit,
  });

  const handleFormChange = (field: string, value: any) => {
    if (field === "release" && value === false) {
      setForm(form => ({ ...form, [field]: value, releaseMonths: 0 }));
      return;
    }
    setForm(form => ({ ...form, [field]: value }));
  };

  useEffect(() => {
    onFormChange({
      ...form,
      months: parseInt(form.months.toString()),
      releaseMonths: parseInt(form.releaseMonths.toString()),
    });
  }, [form]);

  const reTaxesColumns = [
    {
      key: 'description',
      dataIndex: 'description',
      width: '50%',
    },
    {
      key: 'months',
      dataIndex: 'months',
      width: '25%',
    },
    {
      key: 'value',
      dataIndex: 'value',
      width: '25%',
    },
  ];

  const reTaxesDataSource = [
    {
      description: "RE Tax Reserves",
      months: <Input  suffix={<span>%</span>} style={{minWidth:100}} value={form.months} type="number" placeholder="Months" min={0} step={1} onChange={e => handleFormChange('months', parseFloat(e.target.value) || 0)} />,
      value: <NumberField type="money" value={form.yearOneMonthlyAmount * form.months} />,
    },
    {
      description: "RE Tax Reserves - Release",
      months: null,
      value: <Select value={form.release} defaultActiveFirstOption={false} style={{ minWidth:100 }} placeholder="Release" onChange={e => handleFormChange("release", e)}>
        <Option value={true}>Yes</Option>
        <Option value={false}>No</Option>
      </Select>,
    },
    {
      description: "RE Tax Reserves - Release Timing",
      months: <Input  style={{minWidth:100}}  value={form.releaseMonths} disabled={!form.release} type="number" placeholder="Months" min={0} step={1} onChange={e => handleFormChange('releaseMonths',  parseFloat(e.target.value) || 0)} />,
      value: form.release ? <NumberField type="money" value={form.yearOneMonthlyAmount * form.months} /> : <NumberField type="money" value={0}/>,
    },
  ]

  return (
    <Table
      title={() => <b>Real Estate Taxes</b>}
      pagination={false}
      bordered
      size="small"
      showHeader={false}
      columns={reTaxesColumns}
      dataSource={reTaxesDataSource}
      style={{ whiteSpace:'nowrap' }}
      scroll={{x:true}}
    />
  )

}
export default AdditionalReservesDetailsReTaxes;